import { useTranslation } from 'react-i18next'
import styles from './ClassroomRow.module.scss'

const fmtDate = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return '—'
  }
}

const PROVIDER_LABEL = {
  zoom: 'Zoom',
  teams: 'MS Teams',
  jitsi: 'Jitsi',
  other: 'Другое',
}

const isJoinable = (iso) => {
  if (!iso) return false
  try {
    const ts = new Date(iso).getTime()
    const now = Date.now()
    const fifteen = 15 * 60 * 1000
    return Math.abs(ts - now) <= fifteen
  } catch {
    return false
  }
}

const ClassroomRow = ({ classroom, onJoin, joining }) => {
  const { t } = useTranslation('common')

  const provider = classroom.provider || classroom.kind || 'other'
  const scheduledAt = classroom.scheduled_at || classroom.start_at
  const joinable = isJoinable(scheduledAt)
  const lessonTitle =
    classroom.title ||
    classroom.lesson_title ||
    classroom.subject_name ||
    `Занятие #${classroom.id}`

  return (
    <div className={styles.row}>
      <div className={styles.main}>
        <div className={styles.title}>{lessonTitle}</div>
        <div className={styles.meta}>
          <span className={styles.providerBadge}>
            {PROVIDER_LABEL[provider] || provider}
          </span>
          <span className={styles.time}>{fmtDate(scheduledAt)}</span>
        </div>
      </div>
      <div className={styles.actions}>
        <button
          className={`${styles.joinBtn} ${joinable ? '' : styles.joinDisabled}`}
          disabled={!joinable || joining}
          onClick={() => onJoin(classroom)}
        >
          {joining ? 'Подключение…' : 'Присоединиться'}
        </button>
        {!joinable && (
          <div className={styles.hint}>{t('auto.classroomrow_classroomrow.k1')}</div>
        )}
      </div>
    </div>
  )
}

export default ClassroomRow
